import WorkspaceUtils from '@/app/utils/workspace-utils';
import { EventBus } from '@/lib/utils/event-bus';
const eventMethod = window.addEventListener
  ? 'addEventListener'
  : 'attachEvent';
const eventer = window[eventMethod];
const messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

export default class WindowManager {
  window!: Window | null;
  windowOpened!: boolean;

  showLoader(): void {
    if (this.window && !this.window.closed) {
      this.window.close();
    }

    this.window = this.openWindow(
      `${WorkspaceUtils.getCommonUrl()}/common_loader`
    );
    this.windowOpened = false;
  }

  open(url: string, counter = 5): void {
    if (this.windowOpened || counter == 0) {
      if (this.window) {
        this.window.location.replace(url);
      } else {
        this.window = this.openWindow(url);
      }
    } else {
      counter--;
      window.setTimeout(() => {
        this.open(url, counter);
      });
    }
  }

  close(): void {
    this.window && this.window.close();
    this.windowOpened = false;
  }

  markAsOpened() {
    if (this.window && !this.window.closed) {
      this.windowOpened = true;
    }
  }

  closeCallWatch() {
    const watchInterval = window.setInterval(() => {
      if (this.window && this.window.closed) {
        clearInterval(watchInterval);
        EventBus.$emit('tube_window_closed');
      }
    }, 500);
  }

  private openWindow(url) {
    const w = 600;
    const h = 600;
    const left = screen.width / 2 - w / 2;
    const top = screen.height / 2 - h / 2;
    return window.open(
      url,
      'tube-window',
      `width=${w},height=${h},top=${top},left=${left}`
    );
  }
}
